import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="manga-clip-both flex h-9 w-9 items-center justify-center bg-primary-500 text-background-50">
                <i className="ri-palette-line text-lg" />
              </span>
              <span className="font-heading text-xl text-background-50">可游漫画网</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-300">
              汇聚游戏资讯与联动情报，跟进新游漫画化、版本更新漫画及活动漫画内容。游戏情报一站掌握。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50">栏目导航</h4>
            <ul className="mt-4 space-y-2.5">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/${c.slug}`}
                    className="text-sm text-background-300 transition-colors hover:text-accent-400"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50">快捷链接</h4>
            <ul className="mt-4 space-y-2.5">
              <li><Link to="/" className="text-sm text-background-300 hover:text-accent-400">首页</Link></li>
              <li><Link to="/about" className="text-sm text-background-300 hover:text-accent-400">关于我们</Link></li>
              <li><Link to="/contact" className="text-sm text-background-300 hover:text-accent-400">投稿咨询</Link></li>
              <li><Link to="/about" className="text-sm text-background-300 hover:text-accent-400">内容原则</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50">联系我们</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line" />
                contact@keyoumanga.example
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line" />
                可游漫画网
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line" />
                每日 09:00 - 22:00
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-background-700 pt-6 sm:flex-row">
          <p className="text-xs text-background-400">
            © 2026 可游漫画网 · 游戏情报与联动情报站
          </p>
          <p className="text-xs text-background-400">
            本站内容仅供信息参考，版权归原作者所有
          </p>
        </div>
      </div>
    </footer>
  );
}